import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { keycloakUtils } from "itsf-ui-common";

export const useLoginLogout = () => {
    const { pathname } = useLocation();

    const logIn = useCallback(
        (redirectPath?: string) => {
            keycloakUtils.login({
                redirectUri: `${window.location.origin}${redirectPath ?? pathname}`,
            });
        },
        [pathname]
    );

    const logOut = useCallback((redirectPath?: string, logoutCallback?: () => void) => {
        if (logoutCallback) {
            logoutCallback();
        }
        keycloakUtils.logout({
            redirectUri: `${window.location.origin}${redirectPath ?? ""}`,
        });
    }, []);

    return { logIn, logOut };
};
